module.exports = __webpack_public_path__ + "img/AssociationLineStartIcon9.7ad1bb67.svg";